import { formatArabicDate } from '../../../utils/dateformat';
import './timeline.css';

function OrderTimeLine({order}) {
  return (
    <div className="timeline">
      <div className="wrapper">
        <h1>طلبيتي 🚚</h1>
        <ul className="sessions">
          <li className='reached'>
            <div className="time">{formatArabicDate(order.createdAt)}</div>
            <p>تم شحن الطلب 📦</p>
          </li>
          <li className='reached'>

            <div className="time">{formatArabicDate(order.createdAt)}</div>
            <p>في الطريق للتوصيل  🚚</p>
          </li>
          <li className={order.status === "Delivered"? "reached" : ""}>

            {order.status === "Delivered" && <div className="time">{formatArabicDate(order.updatedAt)}</div>}
            {order.status !== "Delivered" && <div className="time"></div>}
            <p>  تم تسليم الطلب 📍</p>
          </li>
          
        </ul>
      </div>
    </div>
  );
}

export default OrderTimeLine;
